import * as React from "react";
import Box from "@mui/material/Box";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select, { SelectChangeEvent } from "@mui/material/Select";
import { CerealSlugs } from "../../../redux/slices/dashboard/dashboard";
import { FC } from "react";
import { syles } from "./CropsMenuStyles";

type CropsMenuParams = {
  cropsSelected: CerealSlugs[];
  setCrop: (crop: { slug: string; translation: string }) => void;
  selectedCrop: { slug: string; translation: string };
  fetchCropInfo: (cropSlug: string) => void;
  t: (key: string) => string;
  allDataResults: { specie: string }[];
};

const CropsMenu: FC<CropsMenuParams> = ({
  cropsSelected,
  setCrop,
  selectedCrop,
  fetchCropInfo,
  t,
  allDataResults,
}) => {
  const handleChange = (event: SelectChangeEvent) => {
    const selectedSlug = event.target.value;
    const selectedCropData = cropsSelected.find(
      (crop) => crop.slug === selectedSlug
    );

    fetchCropInfo(selectedCropData?.slug ?? "barley");

    setCrop({
      slug: selectedCropData?.slug as string,
      translation: selectedCropData?.translation as string,
    });
  };

  const filteredCrops = cropsSelected
    .filter(
      (crop) =>
        allDataResults?.some(
          (data) => data.specie.toLowerCase() === crop.translation.toLowerCase()
        ) ?? false
    )
    .toSorted((a, b) => a.translation.localeCompare(b.translation));

  const hasDataResults = allDataResults && allDataResults.length > 0;
  const hasAvailableCrops = filteredCrops.length > 0;

  return (
    <div style={syles.cropsMenu}>
      <Box sx={syles.cropsSelector}>
        <FormControl fullWidth>
          <InputLabel>{t("DashboardDynamicCharts.crops")}</InputLabel>
          <Select
            value={hasAvailableCrops ? selectedCrop.slug : ""}
            label={t("DashboardDynamicCharts.crops")}
            onChange={handleChange}
          >
            {hasDataResults && hasAvailableCrops ? (
              filteredCrops.map((crop) => (
                <MenuItem key={crop.slug} value={crop.slug}>
                  {crop.translation}
                </MenuItem>
              ))
            ) : (
              <>
                <MenuItem value="" disabled>
                  {hasDataResults
                    ? "No crops available for current data"
                    : t("DashboardDynamicCharts.noDataAvailable") ||
                      "No data available"}
                </MenuItem>
                <MenuItem value="" disabled>
                  {t("DashboardDynamicCharts.noDataAvailableDesc")}
                </MenuItem>
              </>
            )}
          </Select>
        </FormControl>
      </Box>
    </div>
  );
};

export default CropsMenu;
